<template>
	<div class="hotspot-content">
		<template v-if="hotspotPlacements?.length" v-for="(placement, index) in hotspotPlacements" :key="placement.Title">
			<template v-if="placement?.SelectHotspot?.length">
				<ModalHotspot
					v-if="activeHotspotIndex === index"
					:activeHotspotIndex="activeHotspotIndex"
					:index="index"
					:placementsLength="hotspotPlacements.length"
					:placement="placement"
					:hotspotItem="placement?.SelectHotspot[0]"
					@updateActiveHotspotIndex="updateActiveHotspotIndex">
				</ModalHotspot>
			</template>
		</template>
	</div>
</template>

<script lang="ts" setup>
import ModalHotspot from "Vue/components/hotspotComponents/ModalHotspot.vue";
import {HotspotPlacement} from "Interfaces/Interfaces";
const props = defineProps({
	hotspotPlacements: {
		type: Array as () => HotspotPlacement[],
		default: []
	},
	activeHotspotIndex: {
		type: Number,
		default: 0
	},
	backgroundImage: {
		type: String,
		default: ''
	}
});
const emit = defineEmits(['updateActiveHotspotIndex']);

const updateActiveHotspotIndex = (indexValue) => {
	emit('updateActiveHotspotIndex', indexValue);
}

</script>
